const StateList = [
    { text: 'Alabama', value: 'AL' },
    { text: 'Alaska', value: 'AK' },
    { text: 'Arkansas', value: 'AZ' },
    { text: 'Arizona', value: 'AR' },
    { text: 'California', value: 'CA' },
    { text: 'Colorado', value: 'CO' },
    { text: 'Connecticut', value: 'CT' },
    { text: 'District of Columbia', value: 'DC' },
    { text: 'Delaware', value: 'DE' },
    { text: 'Florida', value: 'FL' },
    { text: 'Georgia', value: 'GA' },
    { text: 'Hawaii', value: 'HI' },
    { text: 'Iowa', value: 'IA' },
    { text: 'Idaho', value: 'ID' },
    { text: 'Illinois', value: 'IL' },
    { text: 'Indiana', value: 'IN' },
    { text: 'Kansas', value: 'KS' },
    { text: 'Kentucky', value: 'KY' },
    { text: 'Louisiana', value: 'LA' },
    { text: 'Massachusetts', value: 'MA' },
    { text: 'Maryland', value: 'MD' },
    { text: 'Maine', value: 'ME' },
    { text: 'Michigan', value: 'MI' },
    { text: 'Minnesota', value: 'MN' },
    { text: 'Missouri', value: 'MO' },
    { text: 'Mississippi', value: 'MS' },
    { text: 'Montana', value: 'MT' },
    { text: 'North Carolina', value: 'NC' },
    { text: 'North Dakota', value: 'ND' },
    { text: 'Nebraska', value: 'NE' },
    { text: 'New Hampshire', value: 'NH' },
    { text: 'New Jersey', value: 'NJ' },
    { text: 'New Mexico', value: 'NM' },
    { text: 'Nevada', value: 'NV' },
    { text: 'New York', value: 'NY' },
    { text: 'Ohio', value: 'OH' },
    { text: 'Oklahoma', value: 'OK' },
    { text: 'Oregon', value: 'OR' },
    { text: 'Pennsylvania', value: 'PA' },
    { text: 'Puerto Rico', value: 'PR' },
    { text: 'Rhode Island', value: 'RI' },
    { text: 'South Carolina', value: 'SC' },
    { text: 'South Dakota', value: 'SD' },
    { text: 'Tennessee', value: 'TN' },
    { text: 'Texas', value: 'TX' },
    { text: 'Utah', value: 'UT' },
    { text: 'Virginia', value: 'VA' },
    { text: 'Vermont', value: 'VT' },
    { text: 'Washington', value: 'WA' },
    { text: 'Wisconsin', value: 'WI' },
    { text: 'West Virginia', value: 'WV' },
    { text: 'Wyoming', value: 'WY' },
];

const StateListShortNames = [
    { text: 'AK', value: 'AK' },
    { text: 'AL', value: 'AL' },
    { text: 'AZ', value: 'AZ' },
    { text: 'AR', value: 'AR' },
    { text: 'CA', value: 'CA' },
    { text: 'CO', value: 'CO' },
    { text: 'CT', value: 'CT' },
    { text: 'DC', value: 'DC' },
    { text: 'DE', value: 'DE' },
    { text: 'FL', value: 'FL' },
    { text: 'GA', value: 'GA' },
    { text: 'HI', value: 'HI' },
    { text: 'IA', value: 'IA' },
    { text: 'ID', value: 'ID' },
    { text: 'IL', value: 'IL' },
    { text: 'IN', value: 'IN' },
    { text: 'KS', value: 'KS' },
    { text: 'KY', value: 'KY' },
    { text: 'LA', value: 'LA' },
    { text: 'MA', value: 'MA' },
    { text: 'MD', value: 'MD' },
    { text: 'ME', value: 'ME' },
    { text: 'MI', value: 'MI' },
    { text: 'MN', value: 'MN' },
    { text: 'MO', value: 'MO' },
    { text: 'MS', value: 'MS' },
    { text: 'MT', value: 'MT' },
    { text: 'NC', value: 'NC' },
    { text: 'ND', value: 'ND' },
    { text: 'NE', value: 'NE' },
    { text: 'NH', value: 'NH' },
    { text: 'NJ', value: 'NJ' },
    { text: 'NM', value: 'NM' },
    { text: 'NV', value: 'NV' },
    { text: 'NY', value: 'NY' },
    { text: 'OH', value: 'OH' },
    { text: 'OK', value: 'OK' },
    { text: 'OR', value: 'OR' },
    { text: 'PA', value: 'PA' },
    { text: 'PR', value: 'PR' },
    { text: 'RI', value: 'RI' },
    { text: 'SC', value: 'SC' },
    { text: 'SD', value: 'SD' },
    { text: 'TN', value: 'TN' },
    { text: 'TX', value: 'TX' },
    { text: 'UT', value: 'UT' },
    { text: 'VA', value: 'VA' },
    { text: 'VT', value: 'VT' },
    { text: 'WA', value: 'WA' },
    { text: 'WI', value: 'WI' },
    { text: 'WV', value: 'WV' },
    { text: 'WY', value: 'WY' },
];

const StateNameList = [
    { text: 'Alabama', value: 'alabama' },
    { text: 'Alaska', value: 'alaska' },
    { text: 'Arkansas', value: 'arkansas' },
    { text: 'Arizona', value: 'arizona' },
    { text: 'California', value: 'california' },
    { text: 'Colorado', value: 'colorado' },
    { text: 'Connecticut', value: 'connecticut' },
    { text: 'District of Columbia', value: 'district of columbia' },
    { text: 'Delaware', value: 'delaware' },
    { text: 'Florida', value: 'florida' },
    { text: 'Georgia', value: 'georgia' },
    { text: 'Hawaii', value: 'hawaii' },
    { text: 'Iowa', value: 'iowa' },
    { text: 'Idaho', value: 'idaho' },
    { text: 'Illinois', value: 'illinois' },
    { text: 'Indiana', value: 'indiana' },
    { text: 'Kansas', value: 'kansas' },
    { text: 'Kentucky', value: 'kentucky' },
    { text: 'Louisiana', value: 'louisiana' },
    { text: 'Massachusetts', value: 'massachusetts' },
    { text: 'Maryland', value: 'maryland' },
    { text: 'Maine', value: 'maine' },
    { text: 'Michigan', value: 'michigan' },
    { text: 'Minnesota', value: 'minnesota' },
    { text: 'Missouri', value: 'missouri' },
    { text: 'Mississippi', value: 'mississippi' },
    { text: 'Montana', value: 'montana' },
    { text: 'North Carolina', value: 'north carolina' },
    { text: 'North Dakota', value: 'north dakota' },
    { text: 'Nebraska', value: 'nebraska' },
    { text: 'New Hampshire', value: 'new hampshire' },
    { text: 'New Jersey', value: 'new jersey' },
    { text: 'New Mexico', value: 'new mexico' },
    { text: 'Nevada', value: 'nevada' },
    { text: 'New York', value: 'new york' },
    { text: 'Ohio', value: 'ohio' },
    { text: 'Oklahoma', value: 'oklahoma' },
    { text: 'Oregon', value: 'oregon' },
    { text: 'Pennsylvania', value: 'pennsylvania' },
    { text: 'Puerto Rico', value: 'puerto rico' },
    { text: 'Rhode Island', value: 'rhode island' },
    { text: 'South Carolina', value: 'south carolina' },
    { text: 'South Dakota', value: 'south dakota' },
    { text: 'Tennessee', value: 'tennessee' },
    { text: 'Texas', value: 'texas' },
    { text: 'Utah', value: 'utah' },
    { text: 'Virginia', value: 'virginia' },
    { text: 'Vermont', value: 'vermont' },
    { text: 'Washington', value: 'washington' },
    { text: 'Wisconsin', value: 'wisconsin' },
    { text: 'West Virginia', value: 'west virginia' },
    { text: 'Wyoming', value: 'wyoming' },
];

export default { StateList, StateListShortNames, StateNameList };
